import React from "react";
import { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  FormHelperText,
  Select,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MsgObjetoCreado from "../../componentes/MsgObjetoCreado";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "helpers/API";
import SelectFieldMaterialUI from "form/SelectFieldMaterialUI";
import APIMensajeMUI from "componentes/APIMensajeMUI";
import { errorBackendMsg } from "helpers/helpers";
import { parse, format } from "date-fns";
import { es } from "date-fns/locale";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  cardCrear: {
    height: 120,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
      cursor: "pointer",
    },
  },
  inputNuevaBanda: {
    width: "100%",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

function ProgramacionForm({
  drawer,
  bandaEdit,
  keyLista,
  setKeyLista,
  setRecargarTabla,
}) {
  const classes = useStyles();
  const [creado, setCreado] = useState(null);

  // API Mensaje
  const [mensajeError, setMensajeError] = useState("");
  const [showError, setShowError] = useState(false);
  // API Mensaje Programar
  const [mensajeObjetoCreado, setMensajeObjetoCreado] = useState("");

  //CAMPOS
  const [servidorOpt, setServidorOpt] = useState([]);
  const [servicioOpt, setServicioOpt] = useState([]);
  const [lugarOpt, setLugarOpt] = useState([]);
  const [bandasHorariasOpt, setBandasHorariasOpt] = useState([]);
  ///////

  const [cargando, setCargando] = React.useState(false);

  useEffect(() => {
    listarLugares();
  }, []);

  const peticionBase = ({ url, dataRequest = {}, hook = false }) => {
    axios
      .post(url, dataRequest)
      .then(function (response) {
        if (response.data.error) {
          setShowError(true);
          setMensajeError(response.data.msg);
        } else {
          if (Boolean(hook)) {
            hook(response.data);
            setCargando(false);
          }
        }
      })
      .catch(function (error) {
        setCargando(false);
        setMensajeError(errorBackendMsg(error));
      });
  };

  const listarLugares = () => {
    let peticion = {
      url: "/generales/lugares/listarPorEtiqueta",
      hook: setLugarOpt,
    };
    peticionBase(peticion);
  };

  const listarServicio = (lugarId) => {
    const hook = (data) => {
      setServicioOpt(data)
      // Si hay un solo servicio cargar automaticamente las bandas horarias
      if(data && data.length === 1 && data[0] && data[0].value){
        const idServicio = data[0].value
        listarBandasHorarias(idServicio)
      }
    }
    let peticion = {
      url: "/generales/servicios/listarPorEtiqueta",
      hook: hook,
      dataRequest: { lugarId: lugarId },
    };

    peticionBase(peticion);
  };


  const listarBandasHorarias = (servicioId) => {
    let peticion = {
      url: "/bandasHorarias/listarPorEtiqueta",
      hook: setBandasHorariasOpt,
      dataRequest: { servicioId: servicioId },
    };
    peticionBase(peticion);
  };

  const programar = (values) => {
    setCargando(true);
    values.bandaHorarias = values.bandaHorarias.map((banda) => {
      return banda.value;
    });
    const handleRespuesta = (data) => {
      setMensajeObjetoCreado(data.msg);
      setCreado(true);
      setKeyLista(keyLista + 1);
      setRecargarTabla(true);
    };
    let peticion = {
      url: "/programaciones/nuevo",
      hook: handleRespuesta,
      dataRequest: { ...values },
    };
    peticionBase(peticion);
  };

  const validationSchema = Yup.object({
    lugarId: Yup.string().required("Campo obligatorio"),
    servicioId: Yup.string().required("Campo obligatorio"),
    //servidorId: Yup.string().required("Campo obligatorio"),
    bandaHorarias: Yup.array()
      .min(1, "Seleccione al menos una banda horaria")
      .required("Campo obligatorio"),
    fechaDesde: Yup.string().required("Campo requerido"),
    fechaHasta: Yup.string().required("Campo requerido"),
  });

  const formatoFecha = (fecha) => {
    if (!Boolean(fecha)) {
      return fecha;
    }
    return format(
      parse(fecha, "yyyy-MM-dd", new Date(), { locale: es }),
      "dd/MM/yyyy"
    );
  };

  const formik = useFormik({
    initialValues: {
      lugarId: "",
      servicioId: "",
      servidorId: null,
      bandaHorarias: [],
      fechaDesde: "",
      fechaHasta: "",
    },
    enableReinitialize: false,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const buildRequest = {
        ...values,
        activado: false, // Por defecto
        fechaDesde: formatoFecha(values.fechaDesde),
        fechaHasta: formatoFecha(values.fechaHasta),
      };
      programar(buildRequest);
    },
  });

  return (
    <div
      style={{
        margin: "20px",
        maxWidth: "30vw",
        width: "30vw",
      }}
    >
      {creado && (
        <MsgObjetoCreado
          msg={mensajeObjetoCreado}
          setCreado={setCreado}
          drawer={drawer}
        />
      )}
      <Backdrop className={classes.backdrop} open={cargando}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <form onSubmit={formik.handleSubmit}>
        <Box>
          <Typography variant="h5">Alta Programación</Typography>
        </Box>
        <APIMensajeMUI
          mt={10}
          tipo="error"
          showMensaje={showError}
          msg={mensajeError}
        />
        <Box mt={1}>
          <SelectFieldMaterialUI
            editar={Boolean(bandaEdit)}
            classNameFormControl={classes.inputNuevaBanda}
            disabledFormControl={
              bandaEdit ? bandaEdit.tieneProgramacion : false
            }
            name="lugarId"
            hijosDirectos={["servicioId"]}
            formik={formik}
            itemsArray={lugarOpt}
            ejecutarAccion={(id) => {
              listarServicio(id);
              // Porque a partir tercer select dependiente no es afectado por el cambio
              // quedaría si no, con valores viejos
              setBandasHorariasOpt([])
            }}
          />
        </Box>

        <Box mt={1}>
          <SelectFieldMaterialUI
            editar={Boolean(bandaEdit)}
            classNameFormControl={classes.inputNuevaBanda}
            disabledFormControl={
              bandaEdit ? bandaEdit.tieneProgramacion : false
            }
            name="servicioId"
            hijosDirectos={["bandaHorarias"]}
            multiple
            nombreLabel="Servicio"
            formik={formik}
            itemsArray={servicioOpt}
            reiniciarItemsArray={setBandasHorariasOpt}
            ejecutarAccion={(id) => listarBandasHorarias(id)}
            arrayPadreListener={lugarOpt}
            peticionParaCargarOpcionesAutomatica={(id) => listarServicio(id)}
          />
        </Box>
        <Box mt={1}>
          <FormControl
            variant="outlined"
            className={classes.inputNuevaBanda}
            error={
              formik.touched.bandaHorarias &&
              Boolean(formik.errors.bandaHorarias)
            }
            disabled={bandaEdit ? bandaEdit.tieneProgramacion : false}
          >
            <InputLabel>Bandas Horarias</InputLabel>
            <Select
              variant="outlined"
              label="Bandas Horarias"
              id="bandaHorarias"
              name="bandaHorarias"
              multiple
              value={formik.values.bandaHorarias}
              onChange={formik.handleChange}
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                getContentAnchorEl: null,
              }}
              renderValue={(selected) => (
                <div>
                  {selected.map((item) => {
                    return <Chip key={item.value} label={item.label} />;
                  })}
                </div>
              )}
            >
              {bandasHorariasOpt.map((banda) => {
                return (
                  <MenuItem
                    style={{ whiteSpace: "normal" }}
                    key={banda.value}
                    value={banda}
                  >
                    {banda.label}
                  </MenuItem>
                );
              })}
            </Select>
            <FormHelperText>
              {formik.touched.bandaHorarias && formik.errors.bandaHorarias}
            </FormHelperText>
          </FormControl>
        </Box> 
        <Box mt={1}>
          <TextField
            className={classes.inputNuevaBanda}
            name="fechaDesde"
            label="Fecha Desde"
            type="date"
            onChange={formik.handleChange}
            InputLabelProps={{
              shrink: true,
            }}
            error={
              formik.touched.fechaDesde && Boolean(formik.errors.fechaDesde)
            }
            helperText={formik.touched.fechaDesde && formik.errors.fechaDesde}
          />
        </Box>
        <Box mt={1}>
          <TextField
            className={classes.inputNuevaBanda}
            name="fechaHasta"
            label="Fecha Hasta"
            type="date"
            onChange={formik.handleChange}
            InputLabelProps={{
              shrink: true,
            }}
            error={
              formik.touched.fechaHasta && Boolean(formik.errors.fechaHasta)
            }
            helperText={formik.touched.fechaHasta && formik.errors.fechaHasta}
          />
        </Box>
        <Box mt={3} style={{ float: "right" }}>
          <Button type="submit" variant="contained" color="secondary">
            Guardar
          </Button>
        </Box>
      </form>
    </div>
  );
}
export default ProgramacionForm;
